var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "kcb-cert"
  }, [_vm._t("activator", null, {
    "on": {
      click: _vm.open
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }